<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import getOffsetTop from '@/utilities/getOffsetTop';
    import getPrefix from '@/utilities/getPrefix';

    export default {
        name: 'ParallaxObject',

        props: {
            scale: { type: Number, default: 1 },
            ratio: { type: Number, default: 1 },
        },

        data() {
            return {
                active: true,
            };
        },

        computed: {
            ...mapState('window', [
                'isTouch',
            ]),
        },

        created() {
            this.translation = 0;
            this.currTranslation = 0;
        },

        mounted() {
            this.$nextTick(() => {
                this.$eventHub.$on('resize', this.resize);
                this.$eventHub.$on('update', this.update);

                this.resize();
            });
        },

        beforeDestroy() {
            this.$eventHub.$off('resize', this.resize);
            this.$eventHub.$off('update', this.update);
        },

        methods: {
            resize() {
                if (this.isTouch) {
                    this.active = false;
                } else {
                    this.active = true;
                    this.height = this.$el.offsetHeight;

                    this.offsetY = getOffsetTop(this.$el);
                }
            },

            update() {
                if (!this.active || this.isTouch) return;

                if ((this.offsetY + this.height + Math.abs(this.translation)) >= this.$root.smoothScroll) {
                    this.positionY = this.$root.smoothScroll - this.offsetY;
                    this.translation = this.positionY * this.ratio;

                    this.$el.style[getPrefix('transform')] = `translateY(${-this.translation}px) scale(${this.scale}) translateZ(0)`;
                }
            },
        },
    };
</script>
